import { Card, CardContent, toast } from '@estac1/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiError, api } from '../../lib/api.js';
import { FlagRow } from './billing-form-fields.js';
import type { BillingFlags } from './types.js';

/**
 * Toggle for API error reporting (Sentry). Only has effect when the Worker has
 * SENTRY_DSN configured; switching it off pauses reporting without a deploy.
 */
export const ObservabilityCard = () => {
  const qc = useQueryClient();
  const flags = useQuery({
    queryKey: ['admin-settings-flags'],
    queryFn: () => api.request<BillingFlags>('/v1/admin/settings/flags'),
  });

  const update = useMutation({
    mutationFn: (patch: Pick<BillingFlags, 'errorReportingEnabled'>) =>
      api.request<BillingFlags>('/v1/admin/settings/flags', { method: 'PUT', json: patch }),
    onSuccess: () => {
      toast.success('Monitoramento de erros atualizado.');
      qc.invalidateQueries({ queryKey: ['admin-settings-flags'] });
    },
    onError: (err) => toast.error(err instanceof ApiError ? err.message : 'Falha ao salvar.'),
  });

  const f = flags.data;

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <div>
          <h2 className="text-sm font-semibold">Monitoramento</h2>
          <p className="text-xs text-muted-fg">
            Envia os erros da API para o Sentry. Só funciona quando a chave do Sentry está
            configurada no servidor.
          </p>
        </div>
        {flags.isLoading || !f ? (
          <p className="text-sm text-muted-fg">Carregando...</p>
        ) : (
          <FlagRow
            label="Relatório de erros"
            hint="Dados pessoais (telefone, placa, e-mail) são removidos antes do envio"
            enabled={f.errorReportingEnabled}
            pending={update.isPending}
            onToggle={(v) => update.mutate({ errorReportingEnabled: v })}
          />
        )}
      </CardContent>
    </Card>
  );
};
